import { lazy } from 'react';
import ComponentLoader from 'src/components/ComponentLoader';
import Module from 'src/config/models/Module';
import ModuleBundle from 'src/config/models/ModuleBundle';

export const FirmwareLifecycleViewModule = new Module({
  id: 'FIRMWARE-LIFECYCLE:VIEW:RESULT-TABLE',
  name: 'Firmware Lifecycle',
  label: 'Firmware Lifecycle',
  path: 'firmware-lifecycle',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/FirmwareLifecycles/View'))
  ),
});

const FirmwareLifecycleModules = [
  FirmwareLifecycleViewModule,
];

export default new ModuleBundle('Firmware Lifecycle', FirmwareLifecycleModules);
